<script lang="ts">
    // Zdetails — exibe uma lista de "rótulo + valor" (ex.: dados de uma cobrança, de um pagamento...).
    // Não é uma tabela: cada item vira uma coluna dentro de um ZContainer, no mesmo espírito do Zgrid,
    // mas para dados de exibição avulsos em vez de linhas de uma listagem.
    //
    // A renderização de cada valor usa o mesmíssimo <ZgridLine> que o Zgrid usa pra cada célula — não é
    // uma cópia da lógica, é o componente compartilhado. Então já aceita os tipos do GridColTypeEnum
    // (string, int, float, badge, button, toggle, datetime...) e qualquer melhoria feita nele passa a
    // valer aqui também, e vice-versa.
    //
    // O ZContainer é próprio do componente — basta usar <Zdetails {details} />, sem precisar envolver
    // com nada. Para casos com um campo totalmente customizado (fora do formato rótulo+valor), prefira
    // resolver via os campos de ZDetailItem (content/badge/action) antes de recorrer a markup manual.
    //
    // Recebe um único objeto (DetailsClass), assim como o Zgrid recebe um único `grid: GridClass` — não
    // um array solto — pra dar espaço a novos parâmetros futuros sem mexer na assinatura do componente.
    import { DetailsClass, GridCol, GridColTypeEnum, GridSlot } from './zgrid'
    import ZContainer from './z-container.svelte'
    import ZContainerCol from './z-container-col.svelte'
    import ZgridLine from './zgrid_line.svelte'

    export let details: DetailsClass = new DetailsClass()

    const isMobile = screen.width <= 900
</script>

<ZContainer>
    {#each details.items.filter((item) => item.show !== false) as item}
        <ZContainerCol size={item.size} sizeM={item.sizeM}>
            <div class="zdetails_item" title={item.title || ''}>
                <div class="-label">{item.label}</div>
                <div class="-grid-line">
                    <ZgridLine
                        col={new GridCol({ type: item.type ?? GridColTypeEnum.string, maxLength: item.maxLength })}
                        slot={new GridSlot({ content: item.content, badge: item.badge, action: item.action, class: item.class })}
                        {isMobile}
                        defaultEmptyString={details.defaultEmptyValue ?? '-'}
                    />
                </div>
            </div>
        </ZContainerCol>
    {/each}
</ZContainer>

<style>
    .zdetails_item .-label {
        border-radius: 3px;
        font-size: 13px;
        font-family: consolas;
        opacity: 0.8;
        display: inline-block;
    }

    .zdetails_item .-grid-line {
    }
</style>
